import { render, staticRenderFns } from "./students-information.vue?vue&type=template&id=7e1826a8&"
import script from "./students-information.vue?vue&type=script&lang=js&"
export * from "./students-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports